var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoneyBags = function SvgMoneyBags(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0675 11.982C24.1365 14.1 28.125 19.2 28.125 23.7945C28.125 28.455 23.0835 32.232 18 32.232C12.9165 32.232 7.875 28.455 7.875 23.7945C7.875 19.2 11.8635 14.1 14.9325 11.982L12.6 6.42147C12.5061 6.25752 12.4476 6.07567 12.4284 5.8877C12.4092 5.69973 12.4297 5.50982 12.4885 5.33026C12.5473 5.1507 12.6432 4.98548 12.7699 4.8453C12.8966 4.70512 13.0513 4.5931 13.224 4.51647C16.3241 3.49874 19.6684 3.49874 22.7685 4.51647C22.9419 4.59238 23.0973 4.70388 23.2248 4.84374C23.3523 4.98361 23.4489 5.14871 23.5085 5.32835C23.568 5.50798 23.5891 5.69812 23.5704 5.88644C23.5518 6.07476 23.4937 6.25705 23.4 6.42147L21.0675 11.982Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9326 11.9821H21.0676",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 31.1071C2.25 31.1071 1.125 26.6071 1.125 23.4361C1.19125 21.5779 1.71627 19.7651 2.65324 18.1592C3.59022 16.5532 4.91003 15.2041 6.495 14.2321L4.599 11.4976C4.48215 11.3288 4.41368 11.1313 4.40102 10.9265C4.38835 10.7216 4.43196 10.5172 4.52713 10.3354C4.6223 10.1536 4.7654 10.0012 4.94094 9.89486C5.11647 9.78852 5.31776 9.73221 5.523 9.73206H9",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4935 25.998C15.8183 26.4248 16.2411 26.7671 16.7263 26.9959C17.2114 27.2246 17.7446 27.333 18.2805 27.312C19.989 27.312 21.375 26.2725 21.375 24.99C21.375 23.7075 19.989 22.671 18.2805 22.671C16.572 22.671 15.1875 21.6315 15.1875 20.349C15.1875 19.0665 16.5735 18.0285 18.2805 18.0285C18.8164 18.0068 19.3496 18.1148 19.8348 18.3433C20.32 18.5718 20.7429 18.914 21.0675 19.341",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2803 27.312V28.857",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2803 16.4821V18.0286",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 31.1071C33.75 31.1071 34.875 26.6071 34.875 23.4361C34.8087 21.5779 34.2837 19.7651 33.3468 18.1592C32.4098 16.5532 31.09 15.2041 29.505 14.2321L31.401 11.4976C31.5179 11.3288 31.5863 11.1313 31.599 10.9265C31.6117 10.7216 31.568 10.5172 31.4729 10.3354C31.3777 10.1536 31.2346 10.0012 31.0591 9.89486C30.8835 9.78852 30.6822 9.73221 30.477 9.73206H27",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoneyBags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money-bags.c3a0a147.svg";
export { ForwardRef as ReactComponent };